import React from "react";
import { Row } from "antd";

const Downloads = () => {
    return (
        <Row justify="center">
            <h1>Whats up bro this is the Downloads component</h1>
        </Row>
    )
}

export default Downloads